import { SweepEvent } from '../spline/coneSpanner/SweepEvent';
export class AxisCoordinateEvent extends SweepEvent {
    constructor(p) {
        super();
        this.site = p;
    }
    get Site() {
        return this.site;
    }
}
//# sourceMappingURL=AxisCoordinateEvent.js.map